import {
  Box,
  Button,
  Grid2,
  Typography,
  Paper,
  Divider,
  InputBase
} from "@mui/material";
import { useState, useEffect, useRef } from "react";
import validator from "validator";
import { backendHosts } from "../../../../ui-utils/apiConfig"
import Styles from "./EquityWeb.module.css"
import rightPic from "../../../../ui-utils/latestPics/equityRight.svg"
import leftPic from "../../../../ui-utils/latestPics/equityleft.svg"
import { useLanguage } from "../../../../Context/LangContext";

import en from "../../../../i18n/English/Trade Invest/home.json";
import hi from "../../../../i18n/Hindi/Trade Invest/home.json";
import kn from "../../../../i18n/Kannada/Trade Invest/home.json";
import ma from "../../../../i18n/Marathi/Trade Invest/home.json";
import gu from "../../../../i18n/Gujarati/Trade Invest/home.json";
import { motion } from "framer-motion";
export default function EquityWeb() {
  const [mobileNo, setMobileNo] = useState("");
  const clientErr = {};
  const [mobClientErr, setMobileClientErr] = useState({});
  const MotionGrid = motion(Grid2);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const { language } = useLanguage();
  const translations = { en, hi, kn ,ma,gu};
  const t = translations[language];

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFirstLoad(false); // disable animation after first render
    }, 1200); // match your longest animation duration (e.g., 1s)

    return () => clearTimeout(timer);
  }, []);


  const handleMobilenoEnter = () => {
    const formData = { mobileNo };
    console.log(formData);
    const runValidation = () => {
      if (mobileNo.trim().length == 0) {
        clientErr.mobileNo = "Please Enter your mobile number";
        return;
      }
      if (!validator.isMobilePhone(mobileNo, "en-IN")) {
        console.log("false")
        clientErr.mobileNo = "Please Enter Valid mobile number";
        return;
      }
    };
    runValidation();
    if (Object.keys(clientErr).length == 0) {

      const fullUrl = `${backendHosts.REG}/?mobilenofromhome=${mobileNo}&t=${Date.now()}`;
      window.location.href = fullUrl;
      setMobileClientErr({});

    } else {
      setMobileClientErr(clientErr);
    }
  };

  const handleMobileNoChange = (e) => {
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/\D/g, "");
    const limitedValue = numericValue.slice(0, 10);

    setMobileNo(limitedValue);
  };
  return (
    <>

      <Box className={Styles.HomeSectionBox}>
        <Grid2 container className={Styles.contentWrapper}>

          {
            isFirstLoad ? (
              <MotionGrid
                item
                className={Styles.leftSection}
                sx={{ paddingTop: "80px" }}
                initial={{ opacity: 0, x: -300 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.3, ease: "easeInOut" }}
              >
                <img src={leftPic} alt="equity" className={Styles.leftPic} />

              </MotionGrid>
            ) : (

              <Grid2
                  sx={{ paddingTop: "80px" }}
                className={Styles.leftSection}>
                <img src={leftPic} alt="equity" className={Styles.leftPic} />
              </Grid2>
            )
          }


          {
            isFirstLoad ? (
              <MotionGrid
                item
                className={Styles.centerSection}
                initial={{ opacity: 0, y: -300 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
              >

                <div className={Styles.headingContainer}>
                  <div className={Styles.gradientBackground}></div>
                  <Typography className={Styles.heading} style={{ fontWeight: 600 }}>
                    {t.heading}
                  </Typography>
                </div>
                <Typography className={Styles.subtitle}>
                  {/* Hey! Ready to trade? Open a Trading account with Tradeboss for great perks and low fees! */}
                  {t.subtitle}
                </Typography>
                <Grid2 className={Styles.fieldCard}>
                  <Paper component="form" className={Styles.mobilefield}>
                    <Typography className={Styles.preMobile}>91</Typography>
                    <Divider className={Styles.divider} orientation="vertical" />
                    <InputBase
                      className={Styles.inputbase}
                      placeholder={t.mobilePlaceholder}
                      value={mobileNo}
                      onChange={handleMobileNoChange}
                    />
                    <Button className={Styles.dematButton} onClick={handleMobilenoEnter}>
                      {/* Open a Demat Account in 7 minutes */}
                      {t.buttonText}
                    </Button>
                  </Paper>

                </Grid2>
                {mobClientErr.mobileNo && (
                  <Typography className={Styles.errMsgg}>{mobClientErr.mobileNo}</Typography>
                )}

              </MotionGrid>
            ) : (
              <Grid2 item
                className={Styles.centerSection}>
                  <div className={Styles.headingContainer}>
                    <div className={Styles.gradientBackground}></div>
                    <Typography className={Styles.heading} style={{ fontWeight: 600 }}>
                      {t.heading}
                    </Typography>
                  </div>
                <Typography className={Styles.subtitle}>
                  {/* Hey! Ready to trade? Open a Trading account with Tradeboss for great perks and low fees! */}
                    {t.subtitle}
                </Typography>
                <Grid2 className={Styles.fieldCard}>
                  <Paper component="form" className={Styles.mobilefield}>
                    <Typography className={Styles.preMobile}>91</Typography>
                    <Divider className={Styles.divider} orientation="vertical" />
                    <InputBase
                      className={Styles.inputbase}
                        placeholder={t.mobilePlaceholder}
                      value={mobileNo}
                      onChange={handleMobileNoChange}
                    />
                    <Button className={Styles.dematButton} onClick={handleMobilenoEnter}>
                      {/* Open a Demat Account in 7 minutes */}
                        {t.buttonText}
                    </Button>
                  </Paper>

                </Grid2>
                {mobClientErr.mobileNo && (
                  <Typography className={Styles.errMsgg}>{mobClientErr.mobileNo}</Typography>
                )}
              </Grid2>
            )
          }

          {
            isFirstLoad ? (
              <MotionGrid
                item
                className={Styles.rightSection}
                sx={{ paddingTop: "190px" }}
                initial={{ opacity: 0, x: 300 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.3, ease: "easeInOut" }}
              >


                <img src={rightPic} alt="equity" className={Styles.rightPic} />

              </MotionGrid>
            ) : (
              <Grid2 item
                  sx={{ paddingTop: "190px" }}
                className={Styles.rightSection}>
                <img src={rightPic} alt="equity" className={Styles.rightPic} />
              </Grid2>
            )
          }


        </Grid2>
      </Box>


    </>
  )
}